import '@mdi/font/css/materialdesignicons.css'
import 'typeface-roboto/index.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

import {Touch} from 'vuetify/lib/directives'
import i18n from '@/i18n'
import IconFormatLineSpacingDown from '@/components/icons/IconFormatLineSpacingDown.vue'

Vue.use(Vuetify, {
  directives: {
    Touch,
  },
})

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: {
      formatLineSpacingDown: {
        component: IconFormatLineSpacingDown,
      },
    },
  },

  lang: {
    t: (key, ...params) => i18n.t(key, params).toString(),
  },

  theme: {
    // Tsuki is a dark-first app: dark is the default, the light theme is kept working but secondary.
    dark: true,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        base: colors.shades.white,
        primary: '#5643cf',
        secondary: '#7c6cff',
        accent: '#7c6cff',
        'contrast-1': colors.grey.lighten4,
        'contrast-light-2': colors.grey.darken2,
        'diff': colors.green.lighten4,
        // Tsuki surface tokens
        'surface-0': '#ffffff',
        'surface-1': '#f4f4f7',
        'surface-2': '#e9e9ef',
        'surface-3': '#dededf',
        'border-subtle': '#e2e2e8',
      },
      dark: {
        base: colors.shades.black,
        primary: '#9c8fff',
        secondary: '#7c6cff',
        accent: '#7c6cff',
        'contrast-1': '#17161d',
        'contrast-light-2': colors.grey.lighten2,
        'diff': colors.green.darken4,
        // Tsuki surface tokens — near-black page, slightly lifted panels
        'surface-0': '#0b0a10',
        'surface-1': '#121117',
        'surface-2': '#1a1922',
        'surface-3': '#23222d',
        'border-subtle': '#26252f',
      },
    },
  },
})
